import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect3InV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 33V63H31" stroke="#FFDD00" strokeWidth="2" />
      <path d="M63 0V30L33 30" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
